import { useBadgingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { PageError } from '@juvare/common-web-ui/PageError';
import { Box, CircularProgress, Tab, Tabs } from '@mui/material';
import React from 'react';
import { useParams, useSearchParams } from 'react-router';
import { useStorageGetBadgeDetails } from '../../hooks/useStorageGetBadgeDetails';
import { badgeDetailsTabNames, searchParamKeyFilter, searchParamKeyTab } from '../../utils/manageBadgesRoutes';
import { AccountBadgeTable } from '../AccountBadgeTable/AccountBadgeTable';
import { BadgeDetailsPageHeader } from './BadgeDetailsPageHeader';
import { BadgeHistoryTable } from './BadgeHistoryTable';
export const BadgeDetailsPage = () => {
    const { tabs, selectedTab, handleTabChange } = useBadgeDetailsTabs();
    const { badgeId } = useParams();
    const { data, isLoading, fetchBadgeDetails } = useStorageGetBadgeDetails({ badgeId });
    if (isLoading) {
        return (React.createElement(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' },
            React.createElement(CircularProgress, null),
            ";"));
    }
    if (!data) {
        return (React.createElement(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' },
            React.createElement(PageError, { type: 'not-found' })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(BadgeDetailsPageHeader, { badge: data, fetchBadgeDetails: fetchBadgeDetails }),
        React.createElement(Box, { display: 'flex', flexDirection: 'column' },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    px: 4,
                    borderBottom: 1,
                    borderColor: 'divider',
                    boxShadow: 1,
                    zIndex: 1,
                } },
                React.createElement(Tabs, { variant: 'scrollable', value: selectedTab, onChange: handleTabChange }, tabs.map((tab) => (React.createElement(Tab, { key: tab.value, label: tab.label, value: tab.value, "data-test": `tab-${tab.value}` }))))),
            React.createElement(Box, { sx: { px: 4, py: 3, backgroundColor: themeColors.background } },
                React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 1 },
                    selectedTab === 'assigned-accounts' && (React.createElement(AccountBadgeTable, { badgeId: data.id, accountBadges: data.accountBadges, refetchBadgeDetails: fetchBadgeDetails })),
                    selectedTab === 'history' && React.createElement(BadgeHistoryTable, { badgeId: data.id }))))));
};
function useBadgeDetailsTabs() {
    var _a;
    const { t } = useBadgingTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const tabs = [
        { value: 'assigned-accounts', label: t('badges.badgeDetails.tabNameAssignedAccounts') },
        { value: 'history', label: t('badges.badgeDetails.tabNameHistory') },
    ];
    const selectedTab = (_a = badgeDetailsTabNames.find((tabName) => tabName === searchParams.get(searchParamKeyTab))) !== null && _a !== void 0 ? _a : tabs[0].value;
    const handleTabChange = (_, value) => {
        setSearchParams((prevValues) => {
            prevValues.set(searchParamKeyTab, value);
            prevValues.delete(searchParamKeyFilter);
            return prevValues;
        }, { replace: true });
    };
    return {
        tabs,
        selectedTab,
        handleTabChange,
    };
}
